var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureFlagInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.799,
    height: 16.799,
    viewBox: "0 0 16.799 16.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sliders-02-svgrepo-com",
    d: "M4.7,18.3V13.2m0,0A1.7,1.7,0,1,0,3,11.5,1.7,1.7,0,0,0,4.7,13.2Zm0-6.8V3m5.95,15.3V13.2m0-6.8V3m0,3.4a1.7,1.7,0,1,0,1.7,1.7A1.7,1.7,0,0,0,10.649,6.4ZM16.6,18.3V14.9m0,0a1.7,1.7,0,1,0-1.7-1.7A1.7,1.7,0,0,0,16.6,14.9Zm0-6.8V3",
    transform: "translate(-2.25 -2.25)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureFlagInactive);
export default __webpack_public_path__ + "static/media/featureFlagInactive.58a8cea315100ae1f6332e0251fa4c51.svg";
export { ForwardRef as ReactComponent };